import { Analytics } from './analytics';
import { AddRecommendationItemAction } from '../../../search/addRecommendationItem/actions/add_recommendation_item_action';

export class AddRecommendationVariationAnalytics extends Analytics {
  constructor() {
    super();
    AddRecommendationItemAction.ADD_RECOMMENDATION_VARIATION_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          events: ['event270'],
          server: 'club/pc',
          fName: 'バリエーションを推奨品に登録',
          soloel: {
            events: ['event62'],
            server: 'soloel/pc',
            prop5: 'バリエーションを推奨品に登録'
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', 'AddRecomVariation');
      });
    });
    AddRecommendationItemAction.ADD_RECOMMENDATION_VARIATION_FINISH_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          events: ['event271'],
          server: 'club/pc',
          fName: 'バリエーションを推奨品に登録完了',
          soloel: {
            events: ['event64'],
            server: 'soloel/pc',
            prop5: 'バリエーションを推奨品に登録完了'
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', 'AddFinRecomVariation');
      });
    });
  }
}
